<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista inicio,vista principal del portal
    * Autor: 
    * F.Creación: 
  -->
  <layout>
    <!-- Contenido -->
    <template v-slot:content>
      <v-card class="mx-auto">
        <v-container fluid class="hidden-sm-and-down">
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-card outlined>
                <v-container fluid>
                  <v-row>
                    <v-col cols="auto">
                      <v-card-title style="text-size: 15rem;" class="headline">
                        <h1 class="primary--text" >TSMX Digital</h1>
                      </v-card-title>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="auto">
                      <v-card-subtitle><h3>Administración Inteligente | v{{ appVersion}}</h3></v-card-subtitle>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="hidden-md-and-up">
          <v-row>
            <v-col cols="12">
                      <v-card-title style="text-size: 15rem;" class="headline">
                        <h1 class="primary--text" >TSMX Digital</h1>
                      </v-card-title>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12">
                      <v-card-subtitle><h3>Administración Inteligente | v{{ appVersion}}</h3></v-card-subtitle>
                    </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
  </layout>
</template>




<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";

export default {
  i18n: i18nMessages,
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
  },
  computed: {
    locale() {
      return this.$store.getters["locale"];
    },
    appVersion() {
      return process.env.VUE_APP_VERSION || "0.0.0";
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
    }
  }
};
</script>